<template>
    <sweet-modal :title="$t('subscriptions_createSubscription')" blocking ref="createSubscription" v-on:close="closeModal">
        <el-form ref="form" :model="form" :rules="formRules" size="mini">
            <el-row :gutter="20">
                <el-col :span="12">
                    <el-form-item prop="storage">
                        <el-select style="width:100%;" v-model="form.storage" :placeholder="$t('modal_createSubscription_storageGb')">
                            <el-option
                                    v-for="item in storages"
                                    :key="item"
                                    :label="item"
                                    :value="item">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item prop="usersQty">
                        <el-input type="number" min="1" :label="$t('modal_createSubscription_usersQty')" v-model="form.usersQty" />
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <el-form-item prop="description">
                    <el-input :label="$t('modal_createSubscription_description')" v-model="form.description" />
                </el-form-item>
            </el-row>
            <el-row :gutter="20">
                <el-form-item>
                    <span style="margin-left:10px;">{{$t('modal_createSubscription_price')}}: </span> <span>{{formatPrice(countPrice(form.usersQty, form.storage))}}$</span>
                </el-form-item>
            </el-row>


            <el-form-item>
                <el-button type="primary" size="medium" @click="onSubmit('form')">{{$t('general_save')}}</el-button>
                <el-button size="medium" @click="onCancel">{{$t('general_cancel')}}</el-button>
            </el-form-item>
        </el-form>
    </sweet-modal>
</template>

<script>
  import axios from 'axios'
  import { SweetModal } from '@totalflow4/tfsweet-modal-vue'

  export default {
    name: "CreateSubscriptionModal",
    components:{
      SweetModal
    },
    data(){
      return{
        storages: [1, 5, 10, 20],
        form: {
          description: '',
          usersQty: 1,
          storage: 1
        },
        formRules:{
          description: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' },
          ],
          usersQty: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' },
          ]
        },
      }
    },
    methods:{
      async openModal(){
        try {

          this.$refs.createSubscription.open()

        } catch (err) {
          console.log(err)
        }
      },
      onSubmit(form) {
        this.$refs[form].validate((valid) => {
          if (valid) {
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios.post(`/api/v1/subscription/create?companyId=${this.$route.query.companyId}`, {
              'recurringInterval': '',
              'packageName': '',
              'description': this.form.description,
              'price': '',
              'storage': this.form.storage * 1024 * 1024 * 1024,
              'usersQty': this.form.usersQty
            }).then(data => {
              this.closeModal()
            }).catch(error => {
              this.$notify({
                title: 'Notification',
                message: error.response.data.message,
                type: 'info'
              })
            })
          }
        })
      },
      onCancel() {
        this.$refs.createSubscription.close();
      },
      closeModal() {
        this.form.description = ''
        this.form.usersQty = 1
        this.form.storage = 1
        this.$emit('close')
      },
      notification(title, message, type) {
        this.$notify({
          title: title,
          message: message,
          type: type
        });
      },
      countPrice(qty, storageSize){
        console.log(qty)
        let qtySum = 0;
        let storageSum = 0;
        if (qty) {
          qtySum = parseInt(qty) * 10
        }
        if (storageSize) {
          storageSum = parseInt(storageSize) * 10
        }
        return qtySum + storageSum
      },
      formatPrice(value) {
        let val = (value/1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      }
    }
  }
</script>

<style lang="less" scoped>
    .permissions {
        margin-bottom: 20px;
        &__title {
            font-size:16px;
            margin-bottom: 5px;
            color: #ccc;
        }
    }
</style>
